<template>
  <div class="buy-ticket">
    <h2>我的门票</h2>
    <div class="tabs">
      <div class="bar-list" :class="'selected' + selectedTab">
        <div
          class="tab-bar"
          :class="selectedTab === item.id ? 'selected' : ''"
          v-for="(item, index) in barList"
          :key="index"
          @click="toggleTab(item)"
        >{{ item.text }}</div>
      </div>
      <div class="content">
        <!-- ticketList activeTicket 替换为 buyedTicket currentTicketList -->
        <!-- 我购买的门票 -->
        <slot v-if="selectedTab === 0">
          <div class="tab-pane" v-if="buyedTicket.length > 0">
            <div class="ticket-container">
              <div class="ticket" v-for="(item, index) in buyedTicket" :key="index">
                <div class="status" :class="item.isActivation === '1' ? 'actived' : ''">
                  {{ item.isActivation === "1" ? "已使用" : "未使用" }}
                </div>
                <div class="ticket-number">
                  订单号：<span>{{ item.number }}</span>
                </div>
                <div class="ticket-number">
                  票&nbsp;&nbsp;&nbsp;号：<span>{{ item.bank }}</span>
                </div>
                <h3 class="ticket-name">{{ item.title }}</h3>
                <div class="active-url" v-if="item.isActivation === '0'"
                >激活链接：<a
                  :href="item.linkUrl"
                  :id="item.number"
                  target="_blank"
                  >{{ item.linkUrl }}</a
                ><br /><span @click="copyUrl(item)"
                >点击复制</span></div>
                <div class="active-name" v-else
                >激活人姓名：<span>{{ item.userName }}</span></div>
              </div>
            </div>
            <!-- <div class="page-wrapper" data-desc="分页器">
              <div class="order-page">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :page-size="pageLimit"
                  :page-count="pageCount"
                  :total="allTicketList.length"
                  @current-change="togglePage"
                  @prev-click="togglePage"
                  @next-click="togglePage"
                >
                </el-pagination>
              </div>
            </div> -->
          </div>
          <h3 class="no-ticket" v-else>暂无门票</h3>
        </slot>
        <!-- 我的门票信息('我'激活的门票 -> 属于我的门票,包括自己购买及他人赠与等) -->
        <slot v-if="selectedTab === 1">
          <div class="tab-pane" v-if="currentTicketList.length > 0">
            <div class="ticket-container">
              <div class="my-ticket" v-for="(item, index) in currentTicketList" :key="index">
                <div class="meeting-name"
                >{{ item.schTitle || item.title }}</div>
                <div class="ticket-number"
                >票&nbsp;&nbsp;&nbsp;号：<span>{{ item.bank }}</span></div>
                <h3 class="ticket-name">{{ item.ticketName || item.name }}</h3>
                <div class="look-ticket" v-if="item.isActivation === '0'"
                >激活链接：<a
                  :href="item.linkUrl"
                  :id="'my'+item.number"
                  target="_blank"
                  >{{ item.linkUrl }}</a
                ><br /><span @click="copyUrl(item, 'my'+item.number)"
                >点击复制</span></div>
                <a
                  v-else
                  class="look-ticket"
                  :href="item.electronicTicketUrl || item.ticketUrl"
                  target="_blank"
                >查看我的电子门票</a>
              </div>
            </div>
            <!-- <div class="page-wrapper" data-desc="分页器">
              <div class="order-page">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :page-size="pageLimit"
                  :page-count="ActiveCurrentCount"
                  :total="ActivePageCount.length"
                  @current-change="toggleActivePage"
                  @prev-click="toggleActivePage"
                  @next-click="toggleActivePage"
                >
                </el-pagination>
              </div>
            </div> -->
          </div>
          <h3 class="no-ticket" v-else>暂无门票</h3>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinSession } from '../../mixin'

export default {
  mixins: [mixinSession],
  props: {
    token: String,
    type: String,
    sid: String
  },
  data () {
    return {
      selectedTab: 0,
      barList: [
        { text: '我购买的门票', id: 0 },
        { text: '我的门票信息', id: 1 }
      ],
      allTicketList: [],
      ticketList: [], // 我购买的门票
      currentPage: 1, // 当前为第几页
      pageCount: 0, // 一共有几页
      pageLimit: 4,
      totalAmount: 0, // 订单总金额
      allActiveTicket: [],
      activeTicket: [], // 我的门票信息
      ActiveCurrentCount: 0, // 我的门票当前为第几页
      ActivePageCount: 0, // 我的门票一共有几页
      buyedTicket: [],
      currentTicketList: []
    }
  },
  computed: {
    tabMark () {
      return [this.sid, this.selectedTab]
    }
  },
  // sid, selectedTab
  watch: {
    tabMark: {
      // 监听sid变化，重新获取数据
      handler (newVal, oldVal) {
        if (newVal && newVal[0]) {
          if (newVal[0] && newVal[0] !== (oldVal && oldVal[0])) {
            this.getCurrentTicket()
            // this.getAllTicket()
            this.getCurrentActive()
            // this.getAllActiveTicket()
          } else if (newVal[1] && newVal[1] !== (oldVal && oldVal[1])) {
            if (newVal[1] === 0) {
              this.getCurrentTicket()
            } else {
              this.getCurrentActive()
            }
          }
        }
      },
      immediate: true
    }
  },
  // created () {
  //   if (this.sid) {
  //     this.getCurrentTicket()
  //     // this.getAllTicket()
  //     this.getCurrentActive()
  //     // this.getAllActiveTicket()
  //   }
  // },
  methods: {
    // 切换数据
    togglePage (page) {
      this.currentPage = page
      this.getCurrentTicket()
    },
    toggleActivePage (page) {
      this.currentPage = page
      this.getCurrentActive()
    },
    toggleTab (item) {
      this.selectedTab = item.id
    },
    // 复制链接
    copyUrl (item, id) {
      window.getSelection().removeAllRanges()
      // const number = item.number;
      // let copyDOM = this.$refs[number]
      let copyDOM = document.getElementById(`${id || item.number}`)
      let range = document.createRange()
      range.selectNode(copyDOM)
      window.getSelection().addRange(range)
      try {
        let successful = document.execCommand('copy')
        console.log('copy-success', successful)
        window.alert('复制成功')
      } catch (e) {
        window.alert('复制失败')
      }
      window.getSelection().removeAllRanges()
    },

    // 我自己购买的门票
    getCurrentTicket () {
      // this.getTicketList()
      this.getTicketUniversal(1)
    },
    // 我自己拥有的门票
    getCurrentActive () {
      // this.getActiveTicket()
      this.getTicketUniversal(2)
    },

    getTicketUniversal (flag = 2) {
      let url = `${this.global.urlNew.universal.ticket}?token=${this.token}&type=all&sid=${this.sid}&flag=${flag}`
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          console.log('get-ticket-list ', data)
          if (data.status && [200, '200'].includes(data.status)) {
            if (parseInt(flag) === 1) {
              this.buyedTicket = data.data
            } else {
              this.currentTicketList = data.data
            }
          } else if (data.status && [1026, 1008, '1026', '1008'].includes(data.status)) {
            this.$message('当前登录状态已过期，请重新登录')
            window.localStorage.removeItem('logins')
            window.localStorage.removeItem('token')
            this.$router.push(this.formatHref('/login'))
          } else {
            console.log('服务器繁忙，请重试')
          }
        })
    },

    // ticketList
    getTicketList () { // 分页
      const url = `https://www.msup.com.cn/api/api-common/get-all-ticket`
      const params = `?token=${this.token}&type=${this.type}&sid=${this.sid}&page=${this.currentPage}&limit=${this.pageLimit}&relation=true`
      this.$http
        .jsonp(url + params)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log('get-current-ticket ', data);
          if (data.status) {
            const status = data.status.toString()
            if (status === '200') {
              this.ticketList = data.data
            } else if (status === '1026' || status === '1008') {
              // window.alert('当前登录状态已过期，请重新登录');
              this.$message({ message: '当前登录状态已过期，请重新登录', type: 'warning' })
              window.localStorage.removeItem('token')
              window.localStorage.removeItem('uid')
            } else {
              console.log('服务器繁忙，请重试')
            }
          }
        })
    },
    // allTicketList
    getAllTicket () {
      const url = `https://www.msup.com.cn/api/api-common/get-all-ticket`
      const params = `?token=${this.token}&type=${this.type}&sid=${this.sid}&relation=true`
      this.$http
        .jsonp(url + params)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log('get-all-ticket ', data);
          if (data.status) {
            const status = data.status.toString()
            if (status === '200') {
              this.allTicketList = data.data
            } else if (status === '1026' || status === '1008') {
              // window.alert('当前登录状态已过期，请重新登录');
              this.$message({ message: '当前登录状态已过期，请重新登录', type: 'warning' })
              window.localStorage.removeItem('logins')
              window.localStorage.removeItem('token')
              window.localStorage.removeItem('uid')
            } else {
              console.log('服务器繁忙，请重试')
            }
          }
        })
    },
    // activeTicket
    getActiveTicket () { // 分页
      const url = `https://www.msup.com.cn/api/api-common/get-all-activation-ticket`
      const params = `?token=${this.token}&type=${this.type}&sid=${this.sid}&page=${this.ActiveCurrentCount}&limit=${this.pageLimit}&choose=1`
      this.$http
        .jsonp(url + params)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log('get-current-active ', data);
          if (data.status) {
            const status = data.status.toString()
            if (status === '200') {
              this.activeTicket = data.data
            } else if (status === '1026' || status === '1008') {
              // window.alert('当前登录状态已过期，请重新登录');
              this.$message({ message: '当前登录状态已过期，请重新登录', type: 'warning' })
              window.localStorage.removeItem('token')
              window.localStorage.removeItem('uid')
            } else {
              console.log('服务器繁忙，请重试')
            }
          }
        })
    },
    // ActivePageCount
    getAllActiveTicket () {
      const url = `https://www.msup.com.cn/api/api-common/get-all-activation-ticket`
      const params = `?token=${this.token}&type=${this.type}&sid=${this.sid}&choose=1`
      this.$http
        .jsonp(url + params)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log('get-all-active-ticket ', data);
          if (data.status) {
            const status = data.status.toString()
            if (status === '200') {
              this.ActivePageCount = data.data
            } else if (status === '1026' || status === '1008') {
              // window.alert('当前登录状态已过期，请重新登录');
              this.$message({ message: '当前登录状态已过期，请重新登录', type: 'warning' })
              window.localStorage.removeItem('token')
              window.localStorage.removeItem('uid')
            } else {
              console.log('服务器繁忙，请重试')
            }
          }
        })
    }
  }
}
</script>

<style lang='scss' scoped>
#app .buy-ticket {
  padding: 33px;
  h2 {
    margin-bottom: 25px;
    color: #5c5c5c;
    font-size: 24px;
  }
  .tabs {
    .bar-list {
      border-bottom: 2px solid #efefef;
      display: flex;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        width: 144px;
        height: 5px;
        bottom: 0;
        background: var(--main-color);
        transition: all linear 0.3s;
      }
      .tab-bar {
        padding: 23px 21px;
        color: #999999;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 1px;
        cursor: pointer;
        &.selected {
          color: #333333;
        }
      }
      &.selected0::before {
        left: 0;
      }
      &.selected1::before {
        left: 144px;
      }
    }
    .content {
      .tab-pane {
        padding-top: 2px;
        padding-left: 9px;
        padding-right: 20px;
        .ticket-container {
          // height: 550px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
        }
        .ticket {
          margin: 21px 6px 0;
          width: 404px;
          height: 254px;
          padding-top: 12px;
          padding-bottom: 19px;
          background: #f8f8f8;
          box-sizing: border-box;
          .status {
            margin-right: 24px;
            position: relative;
            font-size: 14px;
            color: var(--main-color);
            text-align: right;
            &::before {
              content: '';
              position: absolute;
              top: 50%;
              right: 46px;
              transform: translateY(-50%);
              width: 8.5px;
              height: 8.5px;
              border-radius: 50%;
              background: var(--main-color);
            }
            &.actived {
              color: var(--main-color);
            }
            &.actived::before {
              background: var(--main-color);
            }
          }
          .ticket-number {
            margin-bottom: 9px;
            padding-left: 35px;
            font-size: 18px;
            font-weight: 500;
            color: #333;
            letter-spacing: 2px;
            span {
              color: #999;
              font-weight: 300;
              letter-spacing: 0;
            }
          }
          .ticket-name {
            padding: 0 30px;
            margin-top: 20px;
            margin-bottom: 28px;
            text-align: center;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            white-space: break-spaces;
          }
          .active-url {
            text-align: center;
            color: #333;
            font-size: 16px;
            font-weight: 500;
            a {
              text-decoration: underline;
              color: #999;
              font-weight: 300;
            }
            span {
              text-decoration: underline;
              cursor: pointer;
              font-weight: 400;
            }
          }
          .active-name {
            text-decoration: underline;
            text-align: center;
            color: #999999;
            font-size: 14px;
            font-weight: 300;
          }
        }
        .my-ticket {
          margin: 21px 6px 0;
          width: 404px;
          height: 254px;
          padding-top: 12px;
          padding-bottom: 19px;
          background: #f8f8f8;
          box-sizing: border-box;
          .status {
            margin-right: 24px;
            position: relative;
            font-size: 14px;
            color: var(--main-color);
            text-align: right;
            &::before {
              content: '';
              position: absolute;
              top: 50%;
              right: 46px;
              transform: translateY(-50%);
              width: 8.5px;
              height: 8.5px;
              border-radius: 50%;
              background: var(--main-color);
            }
            &.actived {
              color: var(--main-color);
            }
            &.actived::before {
              background: var(--main-color);
            }
          }
          .meeting-name {
            // margin-top: 20px;
            margin-top: 5px;
            margin-bottom: 9px;
            padding-left: 35px;
            font-size: 18px;
            font-weight: 500;
            color: #333;
          }
          .ticket-number {
            margin-bottom: 9px;
            padding-left: 35px;
            font-size: 18px;
            font-weight: 500;
            color: #333;
            letter-spacing: 2px;
            span {
              color: #999;
              font-weight: 300;
              letter-spacing: 0;
            }
          }
          .ticket-name {
            padding: 0 30px;
            margin-top: 24px;
            margin-bottom: 30px;
            text-align: center;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
          }

          .look-ticket {
            margin-left: auto;
            margin-right: auto;
            display: block;
            text-align: center;
            font-size: 16px;
            font-weight: 300;
            cursor: pointer;
          }
          a.look-ticket, .look-ticket a {
            color: #999999;
            text-decoration: underline;
          }
          .look-ticket span {
            text-decoration: underline;
          }
        }
        .page-wrapper {
          padding-top: 30px;
          display: flex;
          justify-content: center;
          .total-page {
            margin-right: 10px;
            font-size: 14px;
            color: #999999;
            display: flex;
            align-items: center;
          }
        }
      }
      .no-ticket {
        padding-top: 100px;
        font-size: 24px;
        font-weight: 500;
        text-align: center;
      }
    }
  }
  @media (max-width: 767px) {
    padding: 10px 4vw;
    .tabs {
      .bar-list {
        .tab-bar {
          font-size: 16px;
        }
      }
      .content {
        .tab-pane {
          padding-left: 4px;
          padding-right: 12px;
          .ticket-container {
            height: auto;
          }
          .ticket {
            height: auto;
            .ticket-number {
              padding-left: 12px;
              font-size: 16px;
            }
            .ticket-name {
              padding: 0 4px;
              font-size: 20px;
            }
          }
          .my-ticket {
            height: auto;
            .meeting-name,
            .ticket-number {
              padding-left: 12px;
              font-size: 16px;
            }
            .ticket-name {
              padding: 0 4px;
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/componentsNew/center/MyTicket.vue